import { Pagination, StatusMessageResponse } from '@shared/models';

export interface FetchErkomListResponse
  extends StatusMessageResponse {
  order_list: ErkomListItemResponse[];
  pagination: Pagination;
}

export interface ErkomListItemResponse {
  id: number;
  clinical_status: string;
  comertial_status: string;
  surgery: string;
  patient: string;
  id_number: number | null;
  medic_name: string;
  surgery_place_location: string;
  patient_health_insurance: string;
  procedure: string;
  implants_number: number;
  material: string;
  cryoanalgesia: boolean;
  isDisabled: false;
}
